module.exports = __webpack_public_path__ + "img/globe-04.188622ba.svg";